import { Tabs } from '@ui/lib/park/ui/tabs';
import { useTranslation } from 'next-i18next';

export const LongShortButtonGroup = ({
  isLong,
  setIsLong,
  ...p
}: Omit<Tabs.RootProps, 'value' | 'onValueChange'> & {
  isLong: boolean;
  setIsLong: (isLong: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Tabs.Root
      variant="longShort"
      size="md"
      value={isLong ? 'long' : 'short'}
      onValueChange={(v) => {
        setIsLong(v.value === 'long');
      }}
      {...p}
    >
      {/* V2: active segments are SOLID accent fills — never translucent accent-on-dark */}
      <Tabs.List boxShadow="none" p="2px" gap="2px">
        <Tabs.Trigger
          flex={1}
          minW="0!"
          flexShrink={1}
          value="long"
          textStyle="headings.small"
          h="32px"
          color="v2.text.muted"
          _selected={{
            color: 'v2.text.onAccent !important',
            backgroundColor: 'v2.long.default',
          }}
          _hover={{ color: 'greyWhite.lightGrey2' }}
          data-cy="LongButton"
        >
          {t('common.Long')}
        </Tabs.Trigger>
        <Tabs.Trigger
          flex={1}
          minW="0!"
          flexShrink={1}
          value="short"
          textStyle="headings.small"
          h="32px"
          color="v2.text.muted"
          _selected={{
            color: 'white !important',
            backgroundColor: 'v2.short.default',
          }}
          _hover={{ color: 'greyWhite.lightGrey2' }}
          data-cy="ShortButton"
        >
          {t('common.Short')}
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs.Root>
  );
};
